import Component from '../colorz/Component';

import device from '../colorz/utils/device';

module.exports = class AttachFile extends Component {
    onInit( el, args) {
        // Initializations
        this.onClick = this.onClick.bind( this );
        this.onChange = this.onChange.bind( this );

        this.el = el;
        this.button = this.el.querySelector('.js-attach-trigger');
        this.inputFile = this.el.querySelector('.js-attach-input');
        this.icon = this.inputFile.dataset.icon;
        this.buttonLabel = this.inputFile.dataset.label;
    }

    onReady() {
        this.button.addEventListener( device.pointerdown, this.onClick );
        this.inputFile.addEventListener( 'change', this.onChange );

    }

    onClick(e){
        this.inputFile.click();
    }

    onChange(e){
        var file = this.inputFile.files[0];
        var fileName = this.el.querySelector('.file-name');

        if (fileName) {
            this.el.removeChild(fileName);
        }

        var newFile = document.createElement('span');
        newFile.classList.add('block', 'file-name');
        newFile.innerHTML = `<svg class="icon">
                                  <use x="" y="" xlink:href="#${this.icon}"></use>
                              </svg> 
                              <span>${file.name}</span>`;
        this.el.insertBefore(newFile, this.button);
        this.changeBtnLabel();
    }

    changeBtnLabel(){
        if (!this.inputFile.files[0]) {
            return;
        }

        this.button.querySelector('label').innerHTML = `Modifier votre ${this.buttonLabel}`
    }

}